(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2219],{

/***/ 75086:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/institutions-universities",
      function () {
        return __webpack_require__(72201);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34051);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10682);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var _LazyMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37462);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70710);













const VideoTestimonials = (props)=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const limitedTestimonials = props.testimonialVideos?.sort((firstVideoTestimonial, secondVideoTestimonial)=>secondVideoTestimonial.id - firstVideoTestimonial.id)?.slice(0, 15);
    const videosCount = props.testimonialVideos?.length || 0;
    const videosSlidersettings = {
        infinite: videosCount > 3,
        arrows: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 1,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    infinite: videosCount > 2,
                    autoplay: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderDots),
                    infinite: videosCount > 1,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.mobileAutoplaySpeed */ .Y$.mobileAutoplaySpeed
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievements),
        style: {
            backgroundColor: props.sectionBgColor || "#ffffff",
            ...props?.parentContainerStyles ?? {}
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerDiv),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().heading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().description),
                                children: props.subTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderContainer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                ...videosSlidersettings,
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().slider),
                                ref: sliderRef,
                                children: limitedTestimonials?.length > 0 && limitedTestimonials?.map((content, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievementsDiv),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    width: "33",
                                                    height: "22",
                                                    viewBox: "0 0 33 22",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                            fill: "#226CF5"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                            fill: "#226CF5"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().videoDiv),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__.LazyLoadComponent, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        iframeClassName: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().studVideo),
                                                        src: content.videoLink,
                                                        title: "YouTube video player",
                                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        children: content.name
                                                    }),
                                                    content?.designation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.designation
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.university
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            props.testimonialVideos?.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrowsClass),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickPrev(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/left-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "left-arrow"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickNext(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/right-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "right-arrow"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoTestimonials);


/***/ }),

/***/ 537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82908);
/* harmony import */ var _styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78182);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45992);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40607);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59830);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70710);













const Testimonial = ({ title , bgColor , slug , data  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: testimonialData , 1: setTestimonialData  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const { 0: centerSlide , 1: setCenterSlide  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const settings = {
        dotsClass: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().sliderDots),
        dots: false,
        infinite: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        initialSlide: 1,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.mobileSpeed */ .Y$.mobileSpeed,
                    arrows: false,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 200
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    dots: false
                }
            }
        ]
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        data ? setTestimonialData(data) : (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(`${"https://cms.studies-overseas.com"}/${slug}`, "GET", {}, "", false).then((res)=>setTestimonialData(res));
    }, []);
    return testimonialData?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        id: "studenttestimonial",
        className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().studentTestSlider),
        style: {
            backgroundColor: bgColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "mb-5 text-center",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "studentmm",
                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().student),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ...settings,
                                    ref: sliderRef,
                                    className: `${(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().slider)}`,
                                    children: testimonialData.map((slide, ind)=>{
                                        return ind < 15 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                className: `${(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().stuTestCard)}`,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Body */ .Z.Body, {
                                                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cardBody),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                            width: "33",
                                                            height: "22",
                                                            viewBox: "0 0 33 22",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                                    fill: "#226CF5"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                                    fill: "#226CF5"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "my-4",
                                                            children: slide?.testimonial?.message
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                            className: "mb-0",
                                                            children: slide?.testimonial?.name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().addre),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: slide?.testimonial?.details
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: slide?.testimonial?.subDetails
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }, ind);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrowsClass),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickPrev(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/left-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "left-arrow"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickNext(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/right-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "right-arrow"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Testimonial);


/***/ }),

/***/ 97761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73017);
/* harmony import */ var _styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40607);









const TopTieUpsOfKC = ()=>{
    const { 0: topTieUps , 1: setTopTieUps  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(`${"https://cms.studies-overseas.com"}/top-university-tie-ups`, "GET", {}, "", false).then((res)=>setTopTieUps(res));
    }, []);
    return topTieUps ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "uni-tie-upmain",
        className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().uniTieUp),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "unitieuptxt",
                        className: `text-center ${(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading)}`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().uniDiv),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: topTieUps?.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: topTieUps?.description
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    id: "unitieupLogo",
                    className: "text-center",
                    children: topTieUps?.images?.length > 0 && topTieUps.images.map((images, index)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            xl: 3,
                            md: 3,
                            xs: 6,
                            className: `${(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cols)} ${index > 3 ? (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().borderl0) : ""}`,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().unidiv),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    src: images?.imageUrl,
                                    alt: images?.imageAltTag,
                                    width: 174,
                                    height: 75
                                })
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center mt-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/universities",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            id: "moreUniId",
                            className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().viewMore),
                            children: "More Universities"
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["default"] = (TopTieUpsOfKC);


/***/ }),

/***/ 72201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ institutions_universities; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/InstitutionUniversities/InstitutionsServices.module.scss
var InstitutionsServices_module = __webpack_require__(9189);
var InstitutionsServices_module_default = /*#__PURE__*/__webpack_require__.n(InstitutionsServices_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./components/WebinarEvents.tsx
var WebinarEvents = __webpack_require__(72350);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./components/Recognition.tsx
var Recognition = __webpack_require__(79767);
// EXTERNAL MODULE: ./components/Testimonial.tsx
var Testimonial = __webpack_require__(537);
// EXTERNAL MODULE: ./components/UniTieUp.tsx
var UniTieUp = __webpack_require__(97761);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
// EXTERNAL MODULE: ./components/kcNewlatestupdates.tsx
var kcNewlatestupdates = __webpack_require__(79465);
// EXTERNAL MODULE: ./components/PST/FrequentlyAskedQuestions.tsx
var FrequentlyAskedQuestions = __webpack_require__(3011);
// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./components/InstitutionUniversities/Events/Events.module.scss
var Events_module = __webpack_require__(72098);
var Events_module_default = /*#__PURE__*/__webpack_require__.n(Events_module);
;// CONCATENATED MODULE: ./components/UI/Icons/PhoneIcon.tsx

const PhoneIcon = ({ width =18 , height =18 , color ="#64647A"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.82197 1H3.28571C2.02335 1 1 2.02335 1 3.28571V5.57143C1 11.8833 6.11675 17 12.4286 17H14.7143C15.9767 17 17 15.9767 17 14.7143V13.1349C17 12.702 16.7554 12.3063 16.3682 12.1127L13.6072 10.7322C12.9851 10.4211 12.2318 10.7332 12.0119 11.393L11.6716 12.4139C11.4511 13.0752 10.7728 13.4688 10.0892 13.3321C7.35347 12.785 5.21502 10.6465 4.66787 7.91076C4.53116 7.22723 4.92483 6.54887 5.58612 6.32843L6.85313 5.9061C7.41967 5.71725 7.7453 5.12406 7.60046 4.54471L6.9307 1.86567C6.80351 1.35691 6.34639 1 5.82197 1Z",
            stroke: color
        })
    });
};
/* harmony default export */ var Icons_PhoneIcon = (PhoneIcon);

;// CONCATENATED MODULE: ./components/UI/Icons/MailIcon.tsx

const MailIcon = ({ width =18 , height =18 , color ="#226CF5"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3333 2.6665H2.66665C1.93027 2.6665 1.33331 3.26346 1.33331 3.99984V11.9998C1.33331 12.7362 1.93027 13.3332 2.66665 13.3332H13.3333C14.0697 13.3332 14.6666 12.7362 14.6666 11.9998V3.99984C14.6666 3.26346 14.0697 2.6665 13.3333 2.6665Z",
                stroke: color,
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6666 4.6665L8.68665 8.4665C8.48083 8.59545 8.24286 8.66384 7.99998 8.66384C7.7571 8.66384 7.51913 8.59545 7.31331 8.4665L1.33331 4.6665",
                stroke: color,
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_MailIcon = (MailIcon);

// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
;// CONCATENATED MODULE: ./components/InstitutionUniversities/Events/Events.tsx







const Events = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "b2b-networking-events",
        className: (Events_module_default())["ev-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Events_module_default())["ev-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: (Events_module_default())["ev-heading"],
                    children: [
                        "B2B Networking",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Events_module_default())["ev-heading-accent"],
                            children: "Events & Webinars"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (Events_module_default())["ev-subtext"],
                    children: "Exclusive platforms for University Representatives to engage directly with KC's leading Study Abroad Partners across India and international locations."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Events_module_default())["ev-grid"],
                    children: constants/* EVENT_ITEMS.map */.Qy.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: (Events_module_default())["ev-card"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Events_module_default())["ev-thumbnail"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: item.thumbnailUrl,
                                        alt: item.thumbnailAlt,
                                        layout: "fill",
                                        objectFit: "cover"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Events_module_default())["ev-body"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (Events_module_default())["ev-category"],
                                            children: item.category
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (Events_module_default())["ev-title"],
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (Events_module_default())["ev-divider"],
                                            "aria-hidden": "true"
                                        }),
                                        item.paragraphs.map((paragraph, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (Events_module_default())["ev-paragraph"],
                                                children: paragraph
                                            }, idx)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Events_module_default())["ev-connect-card"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (Events_module_default())["ev-connect-title"],
                                                    children: "Connect with us"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Events_module_default())["ev-connect-row"],
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (Events_module_default())["ev-connect-icon"],
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: "/images/contcatus/user-icon.svg",
                                                                alt: "User",
                                                                width: 16,
                                                                height: 16
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (Events_module_default())["ev-connect-text"],
                                                            children: item.contact.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Events_module_default())["ev-connect-row"],
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (Events_module_default())["ev-connect-icon"],
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_MailIcon, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: (Events_module_default())["ev-connect-link"],
                                                            href: `mailto:${item.contact.email}`,
                                                            children: item.contact.email
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Events_module_default())["ev-connect-row"],
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (Events_module_default())["ev-connect-icon"],
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PhoneIcon, {
                                                                color: "#226CF5"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: (Events_module_default())["ev-connect-link"],
                                                            href: `tel:${item.contact.phone.replace(/\s+/g, "")}`,
                                                            children: item.contact.phone
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Events_module_default())["bottom-container"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Events_module_default())["bottom-divider"]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (Events_module_default())["bottom-text"],
                                                    children: "We sincerely look forward to your participation and to further strengthening our successful partnership."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, item.id))
                })
            ]
        })
    });
};
/* harmony default export */ var Events_Events = (Events);

;// CONCATENATED MODULE: ./components/InstitutionUniversities/InstitutionsUniServices.tsx
























const InstitutionsUniversitiesPage = (props)=>{
    const router = (0,next_router.useRouter)();
    const settingStuPer = {
        dotsClass: (InstitutionsServices_module_default()).sliderDots,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    };
    const { 0: topTieUps , 1: setTopTieUps  } = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/top-university-tie-ups`, "GET", {}, "", false).then((res)=>setTopTieUps(res));
    }, []);
    const renderCard = (solution)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            className: (InstitutionsServices_module_default()).card,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                className: (InstitutionsServices_module_default()).cardBody,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (InstitutionsServices_module_default()).imgDiv,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: solution.imagePath,
                            alt: solution.imageAltTag,
                            width: 70,
                            height: 70
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        children: solution.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: solution.description
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "institutions-universities-page",
        className: (InstitutionsServices_module_default()).InstitutionServicesPage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InstitutionsServices_module_default()).studentServicesCurve,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InstitutionsServices_module_default()).contentDiv,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    lg: 6,
                                    md: 6,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-block d-sm-none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                    className: (InstitutionsServices_module_default()).mobileBreadCrum,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "/",
                                                            active: true,
                                                            children: "Services"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "",
                                                            children: "For Institutes"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: props.pageData.mainImageUrl || "/images/institutions/institutions.svg",
                                                    alt: props.pageData.mainImageAltTag,
                                                    width: 513,
                                                    height: 424
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (InstitutionsServices_module_default()).servContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                    className: "d-none d-sm-block",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "/",
                                                            active: true,
                                                            children: "Services"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "",
                                                            children: "For Institutes"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: props?.pageData?.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: props?.pageData?.description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: `${(InstitutionsServices_module_default()).enquirebtn} ${`${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`}`,
                                                    onClick: ()=>{
                                                        !props?.pageData?.meta?.jotforms[0]?.jotformid && router.push(props?.pageData?.externalLink);
                                                    },
                                                    children: [
                                                        " ",
                                                        props?.pageData?.bannerBtn?.label || "Enquire Now"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 6,
                                    md: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-none d-sm-block text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: props.pageData.mainImageUrl || "/images/institutions/institutions.svg",
                                            alt: props.pageData.mainImageAltTag,
                                            width: 513,
                                            height: 424
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InstitutionsServices_module_default()).WhyKc,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-5 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Why KC?"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: props?.pageData?.whyKc?.length > 0 && props?.pageData?.whyKc.map((kcBenefit)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 4,
                                    md: 4,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (InstitutionsServices_module_default()).img,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: kcBenefit?.imagePath,
                                                    alt: kcBenefit?.imageAltTag,
                                                    width: 107,
                                                    height: 76
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: kcBenefit?.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: kcBenefit?.description
                                            })
                                        ]
                                    })
                                });
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "high-performance-stud",
                className: (InstitutionsServices_module_default()).highPerformanceStu,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xl: 8,
                                md: 8,
                                xs: 12,
                                className: (InstitutionsServices_module_default()).centered,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "High Performance Student Recruitment Solutions through KC"
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-none d-sm-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: props?.pageData?.studentRecruitmentSolutions?.length > 0 && props?.pageData?.studentRecruitmentSolutions.map((solution, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xl: 6,
                                        md: 6,
                                        xs: 12,
                                        className: index + 1 === props?.pageData?.studentRecruitmentSolutions?.length ? (InstitutionsServices_module_default()).centered : "",
                                        children: renderCard(solution)
                                    });
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-block d-sm-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                ...settingStuPer,
                                className: (InstitutionsServices_module_default()).slider,
                                children: props?.pageData?.studentRecruitmentSolutions?.length > 0 && props?.pageData?.studentRecruitmentSolutions.map((solution, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: renderCard(solution)
                                    });
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Events_Events, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "wrappall-section",
                className: (InstitutionsServices_module_default()).wrappAllSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (InstitutionsServices_module_default()).getInTouch,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (InstitutionsServices_module_default()).expert,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (InstitutionsServices_module_default()).centered,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: "Get in touch with our expert team"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Contact us today to discuss our customized student recruitment solutions for your institution."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/contact-us",
                                                    children: "Contact Us"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: `${(InstitutionsServices_module_default()).enquirebtn} ${`${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`}`,
                                                    children: "Enquire Now"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (InstitutionsServices_module_default()).institutionWebinar,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarEvents["default"], {
                            headingLevel: 2
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (InstitutionsServices_module_default()).institutionUnitie,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniTieUp["default"], {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InstitutionsServices_module_default()).instiRecognitions,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Recognition/* default */.Z, {
                    bgColor: "#B8AAEE"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, {
                title: "Our institutes love us",
                bgColor: "#FFFFFF",
                slug: `testimonials?type=institution&_limit=15&_sort=id:DESC`
            }),
            props.pageData?.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                ...props.pageData.videoTestimonial
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InstitutionsServices_module_default()).instituKcUpdates,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(kcNewlatestupdates["default"], {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InstitutionsServices_module_default()).institutionsBlogs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
            }),
            props.pageData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions/* default */.Z, {
                ...props.pageData.faq
            })
        ]
    });
};
/* harmony default export */ var InstitutionsUniServices = (InstitutionsUniversitiesPage);

// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
;// CONCATENATED MODULE: ./pages/partners/institutions-universities.tsx




const InstitutionsUniversities = (props)=>{
    const { meta  } = props?.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#B8AAEE");
        customStyle.setProperty("--navbar-menu-color", "#0E1B2C");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstitutionsUniServices, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var institutions_universities = (InstitutionsUniversities);


/***/ }),

/***/ 72098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Events_hide-scrollbar__6xaVh","ev-section":"Events_ev-section__5cQcC","ev-container":"Events_ev-container__6Atr9","ev-heading":"Events_ev-heading__kmrN4","ev-heading-accent":"Events_ev-heading-accent__ugUfE","ev-subtext":"Events_ev-subtext__j9TXv","ev-grid":"Events_ev-grid__nMUBF","bottom-container":"Events_bottom-container__pkrAi","bottom-divider":"Events_bottom-divider__gl88p","bottom-text":"Events_bottom-text__ry5eN","ev-card":"Events_ev-card__xJK41","ev-thumbnail":"Events_ev-thumbnail____6df","ev-body":"Events_ev-body__9T1Kx","ev-category":"Events_ev-category__uaNur","ev-title":"Events_ev-title__uCLwD","ev-divider":"Events_ev-divider__rfS_a","ev-paragraph":"Events_ev-paragraph__3x_2T","ev-connect-card":"Events_ev-connect-card__mJn7c","ev-connect-title":"Events_ev-connect-title___y9nS","ev-connect-row":"Events_ev-connect-row__QEAL1","ev-connect-icon":"Events_ev-connect-icon__5Szal","ev-connect-text":"Events_ev-connect-text__pjqn2","ev-connect-link":"Events_ev-connect-link__U7W4N","ev-connect":"Events_ev-connect__zh_Sc"};

/***/ }),

/***/ 9189:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"InstitutionServicesPage":"InstitutionsServices_InstitutionServicesPage__oQ2vS","studentServicesCurve":"InstitutionsServices_studentServicesCurve__yiIYk","contentDiv":"InstitutionsServices_contentDiv__vqwCX","enquirebtn":"InstitutionsServices_enquirebtn__A7s_u","servContent":"InstitutionsServices_servContent__aUPBF","highPerformanceStu":"InstitutionsServices_highPerformanceStu__JT4WJ","centered":"InstitutionsServices_centered__ATFQJ","card":"InstitutionsServices_card__Pb2xV","imgDiv":"InstitutionsServices_imgDiv__zTzHi","cardBody":"InstitutionsServices_cardBody__IhKjI","wrappAllSection":"InstitutionsServices_wrappAllSection__uu6OB","getInTouch":"InstitutionsServices_getInTouch__WLhZB","expert":"InstitutionsServices_expert__Q6k6J","institutionWebinar":"InstitutionsServices_institutionWebinar__TYkzk","webinar_events":"InstitutionsServices_webinar_events__toB3v","instiRecognitions":"InstitutionsServices_instiRecognitions__8P62e","WhyKc":"InstitutionsServices_WhyKc__c52ip","whykcdiv":"InstitutionsServices_whykcdiv__UkvF1","viewMore":"InstitutionsServices_viewMore__gR_Rp","img":"InstitutionsServices_img__UX6Mn","studentServicesWebinarEvent":"InstitutionsServices_studentServicesWebinarEvent__x_hbq","instituKcUpdates":"InstitutionsServices_instituKcUpdates__XFLPM","institutionsBlogs":"InstitutionsServices_institutionsBlogs__11SrJ","studentHelpMainDiv":"InstitutionsServices_studentHelpMainDiv__Di3O_","studentHelp":"InstitutionsServices_studentHelp__wsdEA","uniTieUp":"InstitutionsServices_uniTieUp__q5yt7","cols":"InstitutionsServices_cols__Ef8kk","border0":"InstitutionsServices_border0__FtKcW","borderl0":"InstitutionsServices_borderl0__dChNz","commonQue":"InstitutionsServices_commonQue__R1SHO","tabNav":"InstitutionsServices_tabNav__Q39Kp","navLink":"InstitutionsServices_navLink__1IJCR","tabContent":"InstitutionsServices_tabContent__aLc0T","stuAccordion":"InstitutionsServices_stuAccordion__OQSzA","accordion-button":"InstitutionsServices_accordion-button__k1EsT","collapsed":"InstitutionsServices_collapsed__jmf2d","accoHead":"InstitutionsServices_accoHead__TUq_9","accorBody":"InstitutionsServices_accorBody__N8SaW","institutionTestimonials":"InstitutionsServices_institutionTestimonials__wGID0","studentTestSlider":"InstitutionsServices_studentTestSlider__BXLlL","stuTestCard":"InstitutionsServices_stuTestCard__Fp7_C","studentServicesKcUpdates":"InstitutionsServices_studentServicesKcUpdates__yF7Im","studentFooter":"InstitutionsServices_studentFooter__QNaBP","session":"InstitutionsServices_session__wORUq","sliderDots":"InstitutionsServices_sliderDots__a9ob1"};

/***/ }),

/***/ 73017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uniTieUp":"Unitieup_uniTieUp__tb7S6","cols":"Unitieup_cols__vvM4K","borderl0":"Unitieup_borderl0__x9LQV","border0":"Unitieup_border0__pocJi","viewMore":"Unitieup_viewMore__jrZKp","heading":"Unitieup_heading__tu7PU"};

/***/ }),

/***/ 82908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentServicesPage":"studentservices_studentServicesPage__jDBb9","studentServicesCurve":"studentservices_studentServicesCurve__V6eKt","contentDiv":"studentservices_contentDiv__wEbZf","enquirebtn":"studentservices_enquirebtn__ld5mL","servContent":"studentservices_servContent__PL5SN","WhyKc":"studentservices_WhyKc__sZxHm","viewMore":"studentservices_viewMore__bN0nA","img":"studentservices_img__H06y5","studentServicesWebinarEvent":"studentservices_studentServicesWebinarEvent__YR1_a","studentHelpMainDiv":"studentservices_studentHelpMainDiv__1GWsb","studentHelp":"studentservices_studentHelp__1fO7O","alignTop":"studentservices_alignTop__iMtE_","subAnchor":"studentservices_subAnchor__jRKHU","knowMore":"studentservices_knowMore__Y1q7q","linksDiv":"studentservices_linksDiv__KAP9F","studentServicesKcUpdates":"studentservices_studentServicesKcUpdates__LWcWL","StudentBlogs":"studentservices_StudentBlogs__TKFes","studentFooter":"studentservices_studentFooter__C7T7a","session":"studentservices_session__I15Qa","student":"studentservices_student__R_JgR","middelStuTest":"studentservices_middelStuTest__JJpvH","stuTestCard":"studentservices_stuTestCard__s_G5N","cardBody":"studentservices_cardBody__fAO4I","addre":"studentservices_addre__cGp__","studentTestSlider":"studentservices_studentTestSlider__bff6C","sevenBG":"studentservices_sevenBG__ovks8","sliderDots":"studentservices_sliderDots__PrfDo","slick-slide":"studentservices_slick-slide__Zwpji","slick-center":"studentservices_slick-center__42LQ5","arrowsClass":"studentservices_arrowsClass__pblWv","btcircle":"studentservices_btcircle__uDqgR","arrowsClasses":"studentservices_arrowsClasses__SQl3Q"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,3656,4706,474,5684,9465,2350,3593,2995,9774,2888,179], function() { return __webpack_exec__(75086); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);